import { render } from "./DocumentTranslationsState.vue?vue&type=template&id=656bbd2d&scoped=true&ts=true"
import script from "./DocumentTranslationsState.vue?vue&type=script&lang=ts"
export * from "./DocumentTranslationsState.vue?vue&type=script&lang=ts"

import "./DocumentTranslationsState.vue?vue&type=style&index=0&id=656bbd2d&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-656bbd2d"]])

export default __exports__